export default __webpack_public_path__ + "images/c87b6fc075bdebdd2a365c80dfaee135.svg";